import axios from "axios";
import { baseApiUrl } from "../../../../env";
import axiosInstance from "../../../../Axios/axios";

/**==============================================
 *                GetEnumsValue
 *
 *=============================================**/
const GetEnumsValue = async (reqUnitsBody) => {
  const body = reqUnitsBody.queryKey[1];

  return await axiosInstance.post(`${baseApiUrl}/api/v1/Enum/GetEnumValues`, body);
};
/**==============================================
 *                GetAllPerson
 *=============================================**/
const GetAllPerson = async (reqBody) => {
  const body = reqBody.queryKey[1];

  return await axiosInstance.post(`${baseApiUrl}/api/v1/Person/GetAllPerson`, body);
};

/**==============================================
 *                GetAllEducationalDegree
 *
 *=============================================**/
const GetAllEducationalDegree = async () => {
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/EducationalDegree/GetAllEducationalDegree`
  );
};
/**==============================================
 *                GetAllEmployeeStatus
 *
 *=============================================**/
const GetAllEmployeeStatus = async () => {
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/EmployeeStatus/GetAllEmployeeStatus`
  );
};
/**==============================================
 *
 *  AddPerson
 *
 *=============================================**/
const AddPerson = async (reqBody) => {
  return await axiosInstance.post(`${baseApiUrl}/api/v1/Person/AddPerson`, reqBody);
};

/**==============================================
 *               GetAllProvince
 *=============================================**/

const GetAllProvince = async () => {
  return await axiosInstance.get(`${baseApiUrl}/api/v1/Province/GetAllProvince`);
};
/**==============================================
 *                GetCity
 *
 *=============================================**/
const GetCitiesByProvince = async (reqBody) => {
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/City/GetCitiesByProvince?provinceId=${reqBody}`
  );
};
/**==============================================
 *                EditPersonInfo
 *
 *
 *=============================================**/
const EditPersonInfo = async (reqBody) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/Person/AddOrEditPersonInfo`,
    reqBody
  );
};

/**==============================================
 *                GetBankInfo
 *   
 *=============================================**/
const GetBankInfo = async () => {
  const reqBody={
  page: 1,
  totalRecords: 0,
  pageSize: 100,
  searchTerm: ""
  }
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/BankInfo/GetAllBankInfo`,
    reqBody
  );
};

/**==============================================
 *                GetBankInfoForPeron
 *   
 *=============================================**/
const GetBankInfoForPeron = async () => {
  
  return await axiosInstance.get(
    `${baseApiUrl}/api/v1/Person/GetAllBankInfo`,
    
  );
};

/**==============================================
 *                GetPersonBankInfo
 *  
 *=============================================**/
const GetAllPersonBankInfo = async (body) => {
  const personId=body.queryKey[1]
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/PersonBankInfo/GetAllPersonBankInfo`,
    `${personId}`
  );
};



/**==============================================
 *                AddPersonBankInfo
 *  
 *=============================================**/
const AddPersonBankInfo = async (reqBody) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/PersonBankInfo/AddPersonBankInfo`,
    reqBody
  );
};


/**=======================
 *     DeletePersonBankInfo
 *========================**/
const DeletePersonBankInfo = async (personBankId) => {
  return await axiosInstance.delete(
    `${baseApiUrl}/api/v1/PersonBankInfo/DeletePersonBankInfo?personBankInfoId=${personBankId}`
  );
};

/**=======================
 *     EditPersonBankInfo
 *========================**/
const EditPersonBankInfo = async (reqBody) => {
  return await axiosInstance.put(
    `${baseApiUrl}/api/v1/PersonBankInfo/UpdatePersonBankInfo`,
    reqBody
  );
};


/**==============================================
 *                AddUploadDocument
 *  
 *=============================================**/
const AddUploadDocument = async (reqBody) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/UploadPersonDocuments/AddPersonUploadDocument`,
    reqBody
    ,
    {
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }
  );
};
/**==============================================
 *                AddUploadDocument
 *  
 *=============================================**/
const UpdateDocument = async (reqBody) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/UploadPersonDocuments/UpdatePersonUploadDocument`,
    reqBody
    ,
    {
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }
  );
};
/**==============================================
 *                GetUploadDocument
 *  
 *=============================================**/
const GetUploadDocument = async (reqBody) => {
  const body = reqBody.queryKey[1];
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/UploadPersonDocuments/GetPersonUploadDocument`,
    body
  );
};

/**==============================================
 *                AddUploadContract
 *  
 *=============================================**/
const AddUploadContract = async (reqBody) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/PersonContract/AddPersonContract`,
    reqBody
    ,
    {
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }
  );
};
/**==============================================
 *                EditContract
 *  
 *=============================================**/
const EditContract = async (reqBody) => {
  return await axiosInstance.put(
    `${baseApiUrl}/api/v1/PersonContract/UpdatePersonContract`,
    reqBody
    ,
    {
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

/**==============================================
 *                GetPersonContrat
 *  
 *=============================================**/
const GetPersonContrat = async (reqBody) => {
  const body = reqBody.queryKey[1];
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/PersonContract/GetPersonContract`,
    body
  );
};
/**==============================================
 *                DeleteContract
 *  
 *=============================================**/
const DeleteContract = async (reqBody) => {
  return await axiosInstance.delete(
    `${baseApiUrl}/api/v1/PersonContract/DeletePersonContract?contractId=${reqBody}`
  );
};
/**==============================================
 *                AddDependentInfo
 *  
 *=============================================**/
const AddDependentInfo = async (reqBody) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/DependentInfo/AddDependentInfo`,
    reqBody
  );
};
/**==============================================
 *                GetDependentInfo
 *  
 *=============================================**/
const GetDependentInfo = async (reqBody) => {
  const body = reqBody.queryKey[1];
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/DependentInfo/GetDependentInfoByPersonId`,
    body  );
};
/**==============================================
 *                AddInsuranceInfo
 *  
 *=============================================**/
const AddInsuranceInfo = async (reqBody) => {
  const response= await axiosInstance.post(
    `${baseApiUrl}/api/v1/InsuranceInfo/AddInsuranceInfo`,
    reqBody
  );
  return response?.data?.data
};
/**==============================================
 *                add User Account
 *  
 *  
 *  
 *  
 *=============================================**/
const AddUserAccount=async(body)=>{
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/User/AddUser`,
    body
  );

}
export {
  GetEnumsValue,
  GetAllPerson,
  GetAllEducationalDegree,
  GetAllEmployeeStatus,
  AddPerson,
  GetAllProvince,
  GetCitiesByProvince,
  EditPersonInfo,
  GetBankInfo,
  GetAllPersonBankInfo,
  AddPersonBankInfo,
  DeletePersonBankInfo,
  EditPersonBankInfo,
  AddUploadDocument,
  GetUploadDocument,
  AddUploadContract,
  EditContract,
  DeleteContract,
  GetPersonContrat,
  AddDependentInfo,
  GetDependentInfo,
  AddInsuranceInfo,
  AddUserAccount,
  UpdateDocument ,
  GetBankInfoForPeron
};
